<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <router-view></router-view>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title pb-3">Leads</h3>
            <lead-grid
              :filters="variables"
              :role="getAuthUser.role.role_type"
              :query="query"
              :onClickLead="onClickHandler">
              <div class="filter-controls pull-right" slot="filter">
                <variant-input
                  async
                  :options="searchVariants"
                  v-model="searchFilters"/>
              </div>
            </lead-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LeadGrid from '@/components/LeadGrid';
import VariantInput from '@/components/VariantInput';
import ADMIN_LEADS from '@/graphql/Leads/Admin.gql';
import CLIENT_LEADS from '@/graphql/Leads/Client.gql';

export default {
  components: {
    VariantInput,
    LeadGrid,
  },
  computed: {
    ...mapGetters(['getAuthUser', 'getAuthToken']),
    searchVariants() {
      return [{ label: 'Lead ID', value: 'id' }, { label: 'Text in Answer', value: 'answer' }];
    },
    query() {
      return this.getAuthUser.role.role_type ? CLIENT_LEADS : ADMIN_LEADS;
    },
    variables() {
      return {
        [this.searchFilters.option]: this.searchFilters.text || undefined,
      };
    },
  },
  data() {
    return {
      searchFilters: {
        option: 'id',
      },
    };
  },
  methods: {
    onClickHandler(row) {
      if (this.$router.canSee(['leads.find'])) {
        this.$router.push({ name: 'Lead', params: { id: row.id } });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Search/Search.vue